export const PRODUCT_DETAILS = 'PRODUCT_DETAILS'



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-details/store/mutations-types.js